import React, { useState, useEffect } from "react";
import { BaseUrl, excelDownloadUrl } from "../../Container/BaseUrl/BaseUrl";
import {
  Button,
  Pagination,
  Typography,
  Stack,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Box,
  IconButton,
  Drawer,
  ButtonGroup,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { connect } from "react-redux";
import { setDialedNumberInc} from "../../Redux/Actions/actions";
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import { Download } from "@phosphor-icons/react";
import { TiWarningOutline } from "react-icons/ti";
import { Hourglass } from "react-loader-spinner";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell3,
} from "../../CustomComponent/TableCompoent";
import { toaststyle } from "../../Utils/toaststyle";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";

const mapStateToProps = (state) => {
  return {
    skillset: state.data.skillset,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};

const SalesReport = (props) => {
  let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return new Date(todate) >= new Date(fromdate);
  };

  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [getTransferDate, setgetTransferDate] = useState();
  const [showfilter, setshowfilter] = useState(false);
  const [status, setstatus] = useState("");
  const [missedCallList, setmissedCallList] = useState([]);

  const [agentlist, setAgentlist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [spinner, setspinner] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [sourceAgents, setsourceAgents] = useState("");
  const [DestinationAgents, setDestinationAgents] = useState("");

  const [selectedCalls, setselectedCalls] = useState();
  const [totalcalls, settotalcalls] = useState(0);

  const handleChange = (event, value) => {
    setPage(value);
    if (loggedInAgent.role == "Supervisor") {
      MissedCallsAPiSupervisor();
    } else {
      MissedCallsAPi();
    }
  };

  const MissedCallsAPi = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/salesreport",
        {
          from_date: fromdate,
          to_date: todate,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };
  const MissedCallsAPiSupervisor = (value) => {
    if (!value) {
      setspinner(true);
    }
    axios
      .post(
        BaseUrl + "/contact/listCampaignDetailssupervisor",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: "",
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
          type: status,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setspinner(true);
        if (res.data.status) {
          setmissedCallList(res.data.data);
          settotalcalls(res.data.count);
          setPagination(res.data.count);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        } else {
          setmissedCallList([]);
          settotalcalls(0);
          setPagination(0);
          setTimeout(() => {
            setspinner(false);
          }, 1500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setspinner(false);
        }, 1500);
      });
  };

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (loggedInAgent.role == "Supervisor") {
  //       MissedCallsAPiSupervisor("noSpinner");
  //     } else {
  //       MissedCallsAPi("noSpinner");
  //     }
  //   }, 60000);
  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    MissedCallsAPi();
  }, []);

  const handleCloseDialogBox = () => {
    setopenDialog(false);
  };

  const handleChangeCount = (event) => {
    setselectedCalls(event.target.value);
  };

  const DownloadSalesReport = () => {
    axios
      .post(
        BaseUrl + "/contact/salesexcelreport",
        {
          // agent_id: basedOnRole.role == "Supervisor" ?'':basedOnRole.agent_id,
          from_date: fromdate,
          to_date: todate,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
        {}
      )
      .then((res) => {
        if (res.data.status == true) {
          let file = excelDownloadUrl + res.data.message;
          window.open(file);
          // FileSaver.saveAs(file);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {});
  };

  return (
    // SALES REPORT START 
    <StyledPaper>
      {/* card start here */}
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div className="card-header border-0 d-flex align-items-center justify-content-between px-2" sx={{ fontWeight: 600, color: "#1473e6", }}>
          <div className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}>
            Sales Reports
          </div>
          <div>
            <ButtonGroup variant="contained" aria-label="button group" disableElevation size="small" sx={{
              textTransform: "capitalize",
            }}
            >
              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={DownloadSalesReport}
              >
                <DownloadSimple className="me-2" />
                Download
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setshowfilter(true);
                }}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div className="card-body p-1 vh-71 box-inset" sx={{
          justifyContent: "center",
          display: "flex",
          height: "calc(100% - 40px)",
          display: "flex",
          flexDirection: "column",
          gap: "10",
        }}>
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <>
                  <StyledTableHead className="text-center">
                    <StyledTableRow>
                      {[
                        "Agent",
                        "Brand",
                        "Location",
                        "Sales Name",
                        "Total",
                        "Call Back",
                        "No Answer",
                        "Not Delivered",
                        "Successful",
                        "Switched Off",
                        "Wrong No"
                      ].map((headers) => (
                        <StyledTableCell style={{ minWidth: "150px" }}>
                          {headers}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </StyledTableHead>
                  {spinner ? (
                    <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) :

                    missedCallList.length > 0 ? (
                      missedCallList.map((agent, agentIndex) => (
                        agent.brands.map((brand, brandIndex) => (
                          brand.locations.map((location, locationIndex) => (

                            location.advisors.map((advisor,advisorIndex)=>(

                            <StyledTableRow key={advisorIndex} >

{brandIndex === 0 && locationIndex === 0 && advisorIndex === 0 && (
                             <StyledTableCell3 rowSpan={agent.brands.reduce((acc, b) => acc + b.locations.reduce((lAcc, l) => lAcc + l.advisors.length, 0), 0)}>
                               {agent.agent_name}
                             </StyledTableCell3>
                           )}
                                {locationIndex === 0 && advisorIndex === 0 && (
                             <StyledTableCell3 rowSpan={brand.locations.reduce((acc, l) => acc + l.advisors.length, 0)}>
                               {brand.brand}
                             </StyledTableCell3>
                           )}

{advisorIndex === 0 && (
                             <StyledTableCell3 rowSpan={location.advisors.length}>
                               {location.location}
                             </StyledTableCell3>
                           )}
                              <StyledTableCell3 >{advisor.Salesman}</StyledTableCell3>
                              <StyledTableCell3 >{advisor.total}</StyledTableCell3>
                              <StyledTableCell3>
                                {advisor.callback}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }}>{Math.ceil(advisor.callbackPct)}%</span>

                              </StyledTableCell3>
                              <StyledTableCell3 className="callback-cell">
                                {advisor.noAnswer}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }}>{Math.ceil(advisor.noAnswerPct)}%</span>
                              </StyledTableCell3>
                              <StyledTableCell3 className="callback-cell">
                                {advisor.notDelivered}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }}>{Math.ceil(advisor.notDeliveredPct)}%</span>
                              </StyledTableCell3>
                              <StyledTableCell3 className="callback-cell">
                                {advisor.successful}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }} >{Math.ceil(advisor.successfulPct)}%</span>
                              </StyledTableCell3>
                              <StyledTableCell3 className="callback-cell">
                                {advisor.switchedOff}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }}>{Math.ceil(advisor.switchedOffPct)}%</span>
                              </StyledTableCell3>
                              <StyledTableCell3 className="callback-cell">
                                {advisor.wrongNumber}
                                <br />
                                <span className="position-relative text-success" style={{ float: 'right' }}>{Math.ceil(advisor.wrongNumberPct)}%</span>
                              </StyledTableCell3>
                            </StyledTableRow>
                            )

                          ))
                        ))
                      ))
                    ))
                      : (
                        // Data unavailable start 
                        <Stack
                          sx={{
                            position: "absolute",
                            width: "100%", height: "calc(100vh - 14rem)"
                          }}
                          justifyContent="center"
                          alignContent="center">
                          <Stack className="text-muted"
                            direction="column"
                            justifyContent="center"
                            alignContent="center">
                            <span className="mx-auto">
                              <img
                                src={Nodata}
                                alt="pic"
                                style={{ width: "11rem", userSelect: "none" }}
                              />
                            </span>
                            <span className="mx-auto">
                              <h6
                                className="text-muted mt-3"
                                style={{ fontSize: "13px" }}
                              >
                                Data unavailable
                              </h6>
                            </span>
                          </Stack>
                        </Stack>
                        // Data unavailable end 
                      )}
                </>

              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0 d-none">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                {Math.min(page * 10, pagination)} of {pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}

                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" className="p-3 shadowDrawer" >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack className="p-3" style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}>
            <form>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="fromdate" className="form-label">
                  From
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={fromdate}
                  onChange={(e) => setFromdate(e.target.value)}
                  max={defaultValue}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label htmlFor="todate" className="form-label">
                  To
                </label>
                <input
                  type="date"
                  className="form-control"
                  id=""
                  aria-describedby="date"
                  value={todate}
                  onChange={(e) => setTodate(e.target.value)}
                  max={defaultValue}
                />
                {!isToDateValid() && (
                  <span
                    className="text-danger fw-bold mt-2"
                    style={{ fontSize: "10px" }}
                  >
                    To date cannot be less than from date*
                  </span>
                )}
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={
              {
                position: "absolute",
                bottom: "0",
                background: "#f9f9f9",
                width: "100%",
                boxShadow: "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
              }
            }
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >Close</Button>
            <Button
              className="w-100"
              variant="contained" disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (isToDateValid()) {
                  if (loggedInAgent.role == "Supervisor") {
                    MissedCallsAPi();
                  } else {
                    MissedCallsAPi();
                  }
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>

          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer end  */}
    </StyledPaper>
    // SALES REPORT END 
  );
};

export default connect(mapStateToProps, {
  setDialedNumberInc,
})(SalesReport);
